import t from "./types";
import { AuthAPI, BufferAuthAPI } from "../../../Auth/requestHandler";
import apiType from "../APIResponseActions/type";

// ─── Merchants ────────────────────────────────────────────────────────────────

export const getLotSmartMerchants = (property_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/merchants", "POST", { property_id });
    if (response?.success) {
      await dispatch({ type: t.FETCH_LOTSMART_MERCHANTS, payload: response.data });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message || "Failed to fetch merchants" });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

// ─── Regular Rates ────────────────────────────────────────────────────────────

export const getLotSmartRates = (merchant_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/rates/list", "POST", { merchant_id });
    if (response?.success) {
      await dispatch({ type: t.FETCH_LOTSMART_RATES, payload: response.data });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const createLotSmartRate = (rateData) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/rates/create", "POST", rateData);
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const updateLotSmartRate = (rate_id, rateData) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `lotsmart/rates/update/${rate_id}`, "POST", rateData);
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const deleteLotSmartRate = (rate_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `lotsmart/rates/delete/${rate_id}`, "DELETE");
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

// ─── Special Rates ────────────────────────────────────────────────────────────

export const getLotSmartSpecialRates = (merchant_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/special-rates/list", "POST", { merchant_id });
    if (response?.success) {
      await dispatch({ type: t.FETCH_LOTSMART_SPECIAL_RATES, payload: response.data });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const createLotSmartSpecialRate = (rateData) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/special-rates/create", "POST", rateData);
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const updateLotSmartSpecialRate = (special_id, rateData) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `lotsmart/special-rates/update/${special_id}`, "POST", rateData);
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const deleteLotSmartSpecialRate = (special_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", `lotsmart/special-rates/delete/${special_id}`, "DELETE");
    if (response?.success) {
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: response.message });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

// ─── Gate Control ─────────────────────────────────────────────────────────────

export const openLotSmartGate = (merchant_id, property_id) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/gate/open", "POST", { merchant_id, property_id });
    if (response?.success) {
      await dispatch({ type: t.LOTSMART_GATE_RESULT, payload: response });
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: "Gate opened successfully" });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message || "Gate open failed" });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

// ─── Audit Logs ───────────────────────────────────────────────────────────────

export const getLotSmartAuditLogs = (params) => async (dispatch) => {
  try {
    const response = await AuthAPI("domain", "lotsmart/audit-logs", "POST", params);
    if (response?.success) {
      await dispatch({ type: t.FETCH_LOTSMART_AUDIT_LOGS, payload: response });
    } else {
      await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: response?.message });
    }
    return response;
  } catch (err) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: err.toString() });
  }
};

export const exportLotSmartAuditLogs = (params) => async () => {
  try {
    return await BufferAuthAPI("domain", "lotsmart/audit-logs", "POST", { ...params, exportData: true });
  } catch (err) {
    console.error("exportLotSmartAuditLogs error", err);
  }
};
